import { IQuote } from '../../../../trading/src/trading/models/quote';

export function positionsLevelOneDataFeedHandler(trade: IQuote) {}
